export default __webpack_public_path__ + "static/media/sport.8d186665.svg";